import { createGlobalStyle } from 'styled-components';
import theme from './theme';

export default createGlobalStyle`
  @import url("https://use.typekit.net/ksj1jbh.css");
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body,
  #app {
    width: 100%;
    height: 100%;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-text-stroke: 0;
    /* scroll-behavior: smooth; */
  }

  body {
    font-family: 'Roboto';
    overflow-x: hidden;
  }

  a,
  button {
    outline: none;
    border: none;
    background: transparent;
    text-decoration: none;
    color: ${theme.color.primary};
  }

  main {
    /* text-align: center;
    position: absolute;
    top: 120px;
    left: 0;
    width: 100%;
    height: 100%; */
  }
  /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
`;
